import React, {Component} from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {ProductSKU} from 'services/entities/products';
import {Button} from '@material-ui/core';
import {ExpandedBooking} from 'services/entities/booking';
import {CheckedItemIcon, UncheckedItemIcon} from 'components/Icon';
import {generatePath} from 'react-router';
import RouteURLs from 'RouteURLs';
import './index.scss';
import {formatBookingDate, formatBookingTime} from "util/booking";

interface BookingCardProps extends RouteComponentProps {
  className?: string;
  booking: ExpandedBooking;
}

class BookingCard extends Component<BookingCardProps, any> {
  onViewBookingClick(code: string) {
   this.props.history.push(generatePath(RouteURLs.EDIT_BOOKING_SUCCESS, { code: code}));
  }

  renderCheck(checked: boolean) {
    return checked ? <CheckedItemIcon /> : <UncheckedItemIcon />;
  }

  render() {
    const booking: ExpandedBooking = this.props.booking;
    const hasOutstandingAmount = booking.outstandingAmount && booking.outstandingAmount.amount > 0;
    return <div className={`booking-card ${this.props.className || ''}`} key={booking.code}>
      <h3>{ booking.space.name }</h3>
      <span className="date">{ formatBookingDate(booking) }</span>
      <span className="time">{ formatBookingTime(booking) }</span>
      <ul className="checklist">
        <li>{ this.renderCheck(true) } Space Booked</li>
        <li>{ this.renderCheck(!!booking.products.find(pr => pr.sku !== ProductSKU.FlexiTicket)) } Add-ons Booked</li>
        <li>{ this.renderCheck(!!booking.design) } Design Applied</li>
        <li>{ this.renderCheck(!hasOutstandingAmount) } Invoice Paid</li>
      </ul>
      <Button className="view" onClick={() => this.onViewBookingClick(booking.code)}>View booking</Button>
    </div>;
  }
}

export default withRouter(BookingCard);